import { createComponent as _$createComponent } from "@opentui/solid";
import { render } from "@opentui/solid";
import { createStore } from "./state/store";
import { AppLayout } from "./ui/AppLayout";
export async function start(dbPath) {
  const store = await createStore(dbPath);
  render(() => _$createComponent(AppLayout, {
    store: store
  }), {
    targetFps: 30
  });
}